import styled from 'styled-components'

export const ConfigHeaderExportContainer = styled.div`
    display: flex;
    align-items: center;
    position: relative;

    .label {
        color: ${({ theme }) => theme['gray-800']};
    }

    .configheaderexport-clickable {
        height: 27px;
        /* width: 92px; */
        border-radius: 3px;
        border: 1px solid ${({ theme }) => theme['gray-400']};
        display: flex;
        gap: 6px;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        /* color: #606a80; */
        padding: 0 8px;

        i {
            font-weight: 900;
            color: ${({ theme }) => theme['blue-500']};
        }
    }

    .configheaderexport-clickable:hover {
        cursor: pointer;
    }
`

export const ConfigHeaderExportDropdown = styled.div`
    width: 300px;
    /* background: red; */
    position: absolute;
    top: calc(100%);
    right: 0px;
    border-radius: 3px;
    background: ${({ theme }) => theme['gray-200']};
    border: 1px solid ${({ theme }) => theme['gray-100']};

    .dropdown-tile {
        padding: 15px 18px;
        border-bottom: 1px solid ${({ theme }) => theme['gray-100']};
        span {
            font-size: 13px;
            color: ${({ theme }) => theme['gray-900']};
            text-align: left;
            display: block;
            padding: 5px;
            font-family: 'SourceSansPro-Semibold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
        }
    }
`

export const ExportFormatList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 15px 18px;

    li {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            font-size: 13px;
            color: ${({ theme }) => theme['gray-900']};
            text-align: left;
            display: block;
            padding: 5px;
            font-family: 'SourceSansPro-Semibold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
        }

        .classHidden::-moz-focus-outer {
            display: none;
        }

        .download-span {
            color: ${({ theme }) => theme['blue-500']};
            background: transparent;
            border: none;
        }

        .download-span:hover {
            color: ${({ theme }) => theme['blue-400']};
            &.downloading:hover {
                color: ${({ theme }) => theme['blue-500']};
            }
        }
    }
`
